import styles from "./Error.module.scss";

export const Error = ({ err }: { err: JSX.Element }): JSX.Element => {
  return <div className={styles.error}>{err}</div>;
};
